import { Box } from "@mui/material";
import CommunityMembers from "./CommunityMembers";
import { useCallback, useState } from "react";
import { apiGetRequest } from "../../Helpers/Requests";
import endpoints from "../../Helpers/Endpoints";

function MyMembers() {
  const [memberStats, setMemberStats] = useState({
    communityMembersStat: 1,
    communityRequestsStat: 1,
  });

  const getMemberStats = useCallback(async () => {
    try {
      const response = await apiGetRequest(endpoints.getCommunityMembersStats);
      if (response.status === 200) {
        setMemberStats({
          communityMembersStat: response?.data?.total_members,
          communityRequestsStat: response?.data?.join_requests,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          marginTop: {
            xs: "75px",
            md: "0px",
          },
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <CommunityMembers
          memberStats={memberStats}
          getMemberStats={getMemberStats}
        />
      </Box>
    </>
  );
}
export default MyMembers;
